import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { filterEngagements, useAdvisorBoard } from '@src/components/sco/Advisors/hooks/useAdvisorBoard';
import { advisorsBreadcrumbsWithTrail, useAdvisorsToolbar } from '@src/components/sco/Advisors/hooks/useAdvisorsToolbar';
import { findLockedTeamAdvisor, useAdvisorsAccess } from '@src/components/sco/Advisors/model/access';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { AdvisorsUpgradePage } from '@src/components/sco/Advisors/sections/AdvisorsUpgradePage';
import { engagementDisplayName } from '@src/components/sco/Advisors/utils/mapEngagements';
import { resolveUpgradeMembership, resolveUpgradePaywallIntent } from '@src/components/sco/Advisors/utils/upgradePaywall';
import { ScoAdvisorEngagement } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
const queryString = (value: string | string[] | undefined) => typeof value === 'string' ? value : undefined;
const useUpgradeTargetAdvisorName = () => {
  const $ = _c(23);
  const router = useRouter();
  let t0;
  if ($[0] !== router.query.advisorUserId) {
    t0 = queryString(router.query.advisorUserId);
    $[0] = router.query.advisorUserId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const advisorUserId = t0;
  let t1;
  if ($[2] !== router.query.advisorKey) {
    t1 = queryString(router.query.advisorKey);
    $[2] = router.query.advisorKey;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const advisorKey = t1;
  const t2 = !advisorUserId && !advisorKey;
  let t3;
  if ($[4] !== t2) {
    t3 = {
      skip: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const boardQuery = useAdvisorBoard(t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = gql`
      query UpgradeTargetAdvisorName($userId: String!) {
        userById(userId: $userId) {
          id
          userId
          fullName
          displayName
        }
      }
    `;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== advisorUserId) {
    t5 = {
      userId: advisorUserId
    };
    $[7] = advisorUserId;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = !advisorUserId;
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = {
      variables: t5,
      skip: t6
    };
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const userQuery = useQuery(t4, t7);
  boardQuery.data?.advisorBoard;
  userQuery.data?.userById;
  let t8;
  if ($[12] !== advisorKey || $[13] !== advisorUserId || $[14] !== boardQuery.data?.advisorBoard || $[15] !== userQuery.data?.userById) {
    bb0: {
      if (advisorUserId) {
        let t9;
        if ($[17] !== advisorUserId) {
          t9 = e => e.advisorUserId === advisorUserId || e.advisorUser?.userId === advisorUserId;
          $[17] = advisorUserId;
          $[18] = t9;
        } else {
          t9 = $[18];
        }
        const fromBoard = filterEngagements(boardQuery.data?.advisorBoard).find(t9);
        if (fromBoard) {
          t8 = engagementDisplayName(fromBoard);
          break bb0;
        }
        let t10;
        if ($[19] !== advisorUserId) {
          t10 = findLockedTeamAdvisor({
            userId: advisorUserId
          });
          $[19] = advisorUserId;
          $[20] = t10;
        } else {
          t10 = $[20];
        }
        const fromLocked = t10;
        if (fromLocked) {
          t8 = fromLocked.name;
          break bb0;
        }
        const fromUser = userQuery.data?.userById;
        if (fromUser?.fullName || fromUser?.displayName) {
          t8 = fromUser.fullName || fromUser.displayName;
          break bb0;
        }
      }
      if (advisorKey) {
        let t9;
        if ($[21] !== advisorKey) {
          t9 = findLockedTeamAdvisor({
            navKey: advisorKey
          });
          $[21] = advisorKey;
          $[22] = t9;
        } else {
          t9 = $[22];
        }
        const fromKey = t9;
        if (fromKey) {
          t8 = fromKey.name;
          break bb0;
        }
      }
      t8 = null;
    }
    $[12] = advisorKey;
    $[13] = advisorUserId;
    $[14] = boardQuery.data?.advisorBoard;
    $[15] = userQuery.data?.userById;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export const UpgradeSection = () => {
  const $ = _c(20);
  const router = useRouter();
  const paths = useAdvisorsPaths();
  const {
    canAccessAdvisorTeam,
    canAccessPaidAdvisorTier
  } = useAdvisorsAccess();
  let t0;
  if ($[0] !== router.query.advisorUserId) {
    t0 = queryString(router.query.advisorUserId);
    $[0] = router.query.advisorUserId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const advisorUserId = t0;
  let t1;
  if ($[2] !== router.query.advisorKey) {
    t1 = queryString(router.query.advisorKey);
    $[2] = router.query.advisorKey;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const advisorKey = t1;
  const productId = queryString(router.query.productId);
  const prompt = queryString(router.query.prompt);
  const isTeamTargeted = !canAccessAdvisorTeam && !!(advisorUserId || advisorKey);
  const advisorName = useUpgradeTargetAdvisorName();
  let t2;
  if ($[4] !== canAccessAdvisorTeam || $[5] !== canAccessPaidAdvisorTier) {
    t2 = resolveUpgradeMembership({
      canAccessAdvisorTeam,
      canAccessPaidAdvisorTier
    });
    $[4] = canAccessAdvisorTeam;
    $[5] = canAccessPaidAdvisorTier;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const membership = t2;
  const intent = resolveUpgradePaywallIntent({
    canAccessAdvisorTeam,
    canAccessPaidAdvisorTier,
    isTeamTargeted,
    productId,
    prompt
  });
  let t3;
  if ($[7] !== advisorName || $[8] !== isTeamTargeted || $[9] !== paths.base || $[10] !== paths.upgrade || $[11] !== router.asPath) {
    t3 = isTeamTargeted && advisorName ? advisorsBreadcrumbsWithTrail(paths.base, {
      title: "Upgrade",
      href: paths.upgrade
    }, {
      title: `Message ${advisorName}`,
      href: router.asPath || paths.upgrade
    }) : advisorsBreadcrumbsWithTrail(paths.base, {
      title: "Upgrade",
      href: paths.upgrade
    });
    $[7] = advisorName;
    $[8] = isTeamTargeted;
    $[9] = paths.base;
    $[10] = paths.upgrade;
    $[11] = router.asPath;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t3) {
    t4 = {
      breadcrumbs: t3
    };
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  useAdvisorsToolbar(t4);
  let t5;
  if ($[15] !== advisorName || $[16] !== intent || $[17] !== membership || $[18] !== paths.base) {
    t5 = <AdvisorsUpgradePage advisorName={advisorName} freeHref={paths.base} intent={intent} membership={membership} />;
    $[15] = advisorName;
    $[16] = intent;
    $[17] = membership;
    $[18] = paths.base;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};